<script lang="ts">
	import CategoriesBtn from '$lib/components/common/menu/CategoriesBtn.svelte'
	import ShopsBtn from '$lib/components/common/menu/ShopsBtn.svelte'
	import UniverseSubcats from '$lib/components/menu/UniverseSubcats.svelte'
	import SearchbarSimple from '$lib/modals/search/SearchbarSimple.svelte'
	import { storeHeroMenu } from '$lib/js/stores'
	import { page } from '$app/stores'
	import { getUniverseInfo, is_set_array, is_set_object } from '$lib/js/helpers'
	import { t } from 'svelte-i18n-lingui'
	import type { Universe } from '$lib/js/strapi/types'
	import type { CategoryChildren, CategoryWithChildren } from '$lib/js/elasticsearch/types'
	import { getContextScope } from '$lib/js/helpers/i18n'
	import { fetchJSON } from '$lib/js/helpers/http'

	let menuOptions: Array<{ icon: string, title: string, cat_url: string }> = []
	let uClass = 'visible'

	const scope = getContextScope()

	$: innerWidth = 0

	$: universe_info = getUniverseInfo(
		$page.data?.universes_menu?.universes,
		$page.data?.category?.url_path?.split('/')[1],
	)
	$: univClass = universe_info ? 'universe' : ''
	// FIXME[typing]: here we say that cat_id is a string but later we assign it to a number variable
	/** @type Array<{id: string, name: string, link: string, cat_id: string}> */
	$: menu = []

	$: if (is_set_object(universe_info)) {
		menu = $page.data?.universes_menu?.universes?.filter((univ: Universe) => univ.name === universe_info.name)[0].menu_cats
	} else {
		menu = []
		menuOptions = [
			{ icon: 'badge', title: $t`Our brands`, cat_url: 'brands' },
			{ icon: 'hello', title: $t`News and updates`, cat_url: 'blog' },
			{ icon: 'leaf', title: $t`Sustainability`, cat_url: 'sostenibilidad' },
			{ icon: 'us', title: $t`About us`, cat_url: 'quienes-somos' },
		]
	}

	async function getChildrenCats(cat_id: number) {
		return fetchJSON<CategoryChildren>(`/${scope}/endpoints/children_categories?cat_id=${encodeURIComponent(cat_id)}`)
	}

	let submenu_cat: CategoryChildren | null = null
	let selected_subcategory = 0

	async function openSubmenu(option: any) {
		if (option?.cat_id && innerWidth > 1024) {
			selected_subcategory = option.cat_id
			submenu_cat = await getChildrenCats(option.cat_id)

			setTimeout(() => {
				if (submenu_cat && is_set_array(submenu_cat.children_data) && selected_subcategory !== 0) {
					$storeHeroMenu = 'subcats'
				} else {
					selected_subcategory = 0
					$storeHeroMenu = ''
				}
			}, 250)
		}
	}

	function notOpenSubmenu() {
		selected_subcategory = 0
	}
</script>


<svelte:window bind:innerWidth />

{#key $page.data}
	<div class="header-menu {univClass}">

		<div class="header-menu__inner">
			{#if universe_info}
				<button on:mouseenter={() => selected_subcategory = 0}>
					<CategoriesBtn />
				</button>
			{/if}

			<button on:mouseenter={() => selected_subcategory = 0}>
				<ShopsBtn />
			</button>

			{#if $page.data.mobile === false || innerWidth > 768}
				<nav class="header-menu__slider">
					<div class="header-menu__slider-wrapper">
						<!-- PROMO: Show promotions in menu -->
						<!-- {#if $page.route.id === "/[lang]/c/[...cat_url]" && $page.data.promo_prods?.length >= 1}
							<a href="{$page.url.pathname}?p=1&promo=true" class="menu-promo">¡Promociones!</a>
						{/if} -->

						{#if menu.length > 0}
							{#each menu as option}
								<a
									href="/{scope}/{option.link}"
									on:mouseenter={() => openSubmenu(option)}
									on:mouseleave={() => notOpenSubmenu()}
									class:selected={selected_subcategory === option?.cat_id}
								>{option.name}</a>
							{/each}
						{:else}
							{#each menuOptions as option}
								<a href="/{scope}/{option.cat_url}">
									{#if option.icon}<span class="icon icon-{option.icon}"></span>{/if} {option.title}
								</a>
							{/each}
						{/if}
					</div>
				</nav>
			{/if}
		</div>

		<div class="menu">
			<slot></slot>

			<UniverseSubcats category={submenu_cat} bind:selected={selected_subcategory} />
		</div>
	</div>

	{#if $page.data.mobile === true || innerWidth <= 768}
		<div class="searchbar header-menu__search {uClass}">
			<SearchbarSimple />
		</div>
	{/if}
{/key}


<style lang="scss">
  .menu-promo {
    color: var(--main) !important;
    font-weight: 700;
  }

  .searchbar {
    position: relative;

    @media (min-width: 769px) {
      display: none;
    }
    // .searchbar {
    // 	display: none;
    // 	flex-grow: 1;
    // 	position: relative;
    // 	margin: 0 80px 0 43px;

    // 	@media (min-width: 769px) {
    // 		display: block;
    // 	}
    // }
  }

  .header-menu {
    background: white;
    max-width: 1340px;
    width: calc(100% - 40px);
    padding: 0 20px;
    margin: 0 auto;

    @media (min-width: 769px) {
      padding: 0 20px 0 0;
      margin-left: 0;
    }

    &.universe {
      @media (min-width: 769px) {
        padding: 0 20px 0 30px;
      }

      .header-menu {
        &__inner {
          @media (min-width: 769px) {
            margin-left: 0;
            margin-right: 0;
          }
        }
      }
    }

    &__search {
      transition: all linear 0.25s;
      margin-top: 5px;
      padding: 0 0 12px;
      background: white;
    }

    &__inner {
      display: none;
      align-items: flex-start;
      height: 100%;

      @media (min-width: 769px) {
        display: flex;
      }

      @media (max-width: 768px) {
        align-items: center;
      }

      &.visible {
        @media (max-width: 768px) {
          padding: 7px 0 12px;
        }
      }
    }

    &__slider {
      position: relative;
      height: 39px;
      flex-grow: 1;
      overflow: hidden;

      @media (max-width: 768px) {
        display: none;
      }

      &-wrapper {
        position: absolute;
        top: 0;
        left: 0;
      }

      a {
        display: inline-block;
        padding: 5px 15px 10px;
        color: black;
        transition: all linear 0.125s;

        @media (min-width: 769px) {
          padding: 5px 15px 12px;
        }

        &.selected {
          color: var(--main);

          &::after {
            display: block;
            content: "";
            width: calc(100% + 20px);
            height: 3px;
            background: var(--main);
            margin-top: 9px;
            margin-left: -10px;
          }
        }

        &:hover {
          color: var(--main);
        }

        span.icon {
          margin-right: 5px;
        }
      }

      .parent-cat {
        font-weight: 700;
        margin-right: 0;

        span {
          margin-left: 15px;
        }
      }
    }
  }

  .menu {
    position: sticky;
    top: 0;
    z-index: 9;
  }

  .universe-link {
    display: flex;
    align-items: center;
    line-height: 1;
    width: 145px;

    img {
      height: 28px;
      object-fit: contain;
    }
  }

  .icon-u {
    color: var(--univ-sec);
    font-size: 26px;
    margin-left: -2px;
  }
</style>
